import { render, staticRenderFns } from "./ActivityLogTable.vue?vue&type=template&id=15770718"
import script from "./ActivityLogTable.vue?vue&type=script&lang=ts"
export * from "./ActivityLogTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports